import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { UseFeatureTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/useFeature.trackingInfo";

import * as TrackingService from "../../tracking.service";

export const track = (trackingInfo: UseFeatureTrackingInfo) => {
    const event: AnalyticsEvent<UseFeatureTrackingInfo> = {
        event: EventType.UseFeature,
        payload: {
            eventData: trackingInfo
        }
    };

    TrackingService.track(event);
};
